import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";

export default class Layout extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          {" "}
          <Outlet />{" "}
        </div>
      </div>
    );
  }
}
